export const LIST_DETAILED_VIEW_MODULE_ID = 'list-detailed-view-module';
export const LIST_DETAILED_VIEW_MODULE = () =>
  import('@capital-access/lists/actions').then(m => m.ListDetailedViewModule);
